import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useConf } from "../../context/account/paramsAccount";
import { usePresta } from "../../context/presta/fichePresta";
import { FormattedMessage, IntlProvider } from "react-intl";
import { ListePresta } from "../../interface/retourPrestation/retourPrestation";
import ValidationPresta from "../../components/detailPresta/validationPresta";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { LocalizationProvider } from "@progress/kendo-react-intl";
import Input from "../../components/kendo/input";
import { useError } from "../../context/erreur/erreurContext";
import { formatDateComplet } from "../../functions/date/formatageDate";
import { loadModeHorsligne } from "../../functions/HorsLigne/loadmodeHL";
import { savePrestaHl } from "../../functions/HorsLigne/savePrestaHl";
import InputTextArea from "../../components/kendo/inputTextArea";
import { useModal } from "../../context/modal/modalContext";
import { validPrestation, validPrestationWithPhase } from "../../functions/validPrestation";
import ValidationForm from "../../components/sign";
import { sendAllData } from "../../functions/sendAllPresta";
import RenderSubcategories from "../../components/fichePrestation/renderSubcategories";
import RenderSubNoSouscategories from "../../components/fichePrestation/renderSubNoSouscategories";

export interface InfoPresta {
    responsable: string,
    lieu: string,
    date: Date,
    signatureClient: string,
    signatureResponsable: string,
}
export function AffichePresta() {
    const location = useLocation();
    const { conf } = useConf()
    const { showError } = useError();
    const [details, setDetails]: any = useState(null)

    const [isChecked, setIsChecked] = useState(false)
    const [entete, setEntete]: any = useState(null)
    const { showModal } = useModal()
    const { pvId, devId, dpId } = location.state || {}
    const [currentDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(currentDate);
    const { presta } = usePresta()
    const [maxIndex, setMaxIndex] = useState(0)
    const [localisation, setLocalisation] = useState("")
    const [sendAllPresta, setSendAllPresta] = useState({
        e_pv_id: parseInt(pvId),
        e_dev_id: parseInt(devId),
        e_dp_id: null,
        e_hdate_signature: selectedDate,
        e_signature_client: '',
        e_nom_client: '',
        e_signature_responsable: '',
        e_nom_responsable: '',
        e_lieu_signature: localisation,
        e_observation_html: null,
        e_laisse_sur_place: isChecked,
        e_laisse_sur_place_note: ''
    })
    function changeDate(value: Date) {
        setSelectedDate(value);
    }

    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    useEffect(() => {
        validateForm();
    }, [sendAllPresta]);

    useEffect(() => {
        loadModeHorsligne('prestaHl', conf)
            .then(data => {
                if (data) {
                    const filteredItem = data.find((item: any) => {
                        const matchesPvId = pvId ? item.entete.pv_id === pvId : true;
                        const matchesDevId = devId ? item.entete.dev_id === devId : true;
                        return matchesPvId && matchesDevId;
                    });
                    if (filteredItem) {
                        setEntete(filteredItem.entete);
                        // Ajouter sendAllPresta par phase
                        const updatedDetails = filteredItem.result.map((phase: any) => ({
                            ...phase,
                        }));
                        setDetails(updatedDetails);
                    } else {
                        setDetails([]);
                    }
                } else {
                    setDetails([]);
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    }, [conf]);
    const handleInput = (setter: React.Dispatch<React.SetStateAction<any>>, key: string, value: any) => {
        setter((prevState: any) => ({
            ...prevState,      // Préserver les autres propriétés de l'objet
            [key]: value       // Modifier seulement la propriété ciblée
        }))
    };
    const validateForm = () => {
        const newErrors: { [key: string]: string } = {};
        if (!sendAllPresta.e_lieu_signature) newErrors.localisation = 'Le champ Localisation est requis';
        if (!sendAllPresta.e_hdate_signature) newErrors.selectedDate = 'La date est requise';
        if (!sendAllPresta.e_nom_client) newErrors.nomClient = 'Le nom du client est requis';
        if (!sendAllPresta.e_nom_responsable) newErrors.nomResponsable = 'Le nom du responsable est requis';
        if (!sendAllPresta.e_signature_responsable) newErrors.signatureResponsable = 'La signature du responsable est requise';
        if (!sendAllPresta.e_signature_client) newErrors.signatureClient = 'La signature du client est requise';
        setErrors(newErrors);
    };
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (Object.keys(errors).length === 0) {
            // Soumettre les données
        }
    };
    useEffect(() => {
        savePrestaHl(entete, details, showError, conf)
    }, [details, sendAllPresta])
    const [indexPhase, setIndexPhase] = useState(0)
    function changePhase(index: number) {
        setIndexPhase(index)
    }
    const updateInformationSign = (id: string | boolean, key: string, value: any) => {
        setDetails((prevDetails: any) =>
            prevDetails?.map((phase: any) => ({
                ...phase,
                sous_categorie: phase.sous_categorie.map((sub: any) => {
                    if (sub.rpl_id === id) {
                        return {
                            ...sub,
                            informationSign: {
                                ...sub.informationSign,
                                [key]: value,
                            },
                        };
                    }
                    return sub;
                }),
            }))
        );

        // Mise à jour dans localStorage
        const savedData = localStorage.getItem(`prestaHl_${conf.user.user_code}`);
        let prestas = savedData ? JSON.parse(savedData) : [];
        const updatedPrestas = prestas.map((presta: any) => {
            if (presta.rpl_id === id) {
                return {
                    ...presta,
                    sous_categorie: presta.sous_categorie.map((sub: any) =>
                        sub.rpl_id === id ? { ...sub, sendAllPresta: { ...sub.sendAllPresta, [key]: value } } : sub
                    ),
                };
            }
            return presta;
        });
        localStorage.setItem(`prestaHl_${conf.user.user_code}`, JSON.stringify(updatedPrestas));
    };
    const updateInformationSignNoSousCat = (id: string, key: string, value: any) => {
        // Mise à jour dans setDetails
        setDetails((prevDetails: any) =>
            prevDetails?.map((sub: any) => {
                if (sub.rpl_id === id) {
                    return {
                        ...sub,
                        informationSign: {
                            ...sub.informationSign,
                            [key]: value,
                        },
                    };
                }
                return sub;
            })
        );

        // Mise à jour dans localStorage
        const savedData = localStorage.getItem(`prestaHl_${conf.user.user_code}`);
        let prestas = savedData ? JSON.parse(savedData) : [];
        const updatedPrestas = prestas.map((presta: any) => {
            if (presta.rpl_id === id) {
                return {
                    ...presta,
                    sendAllPresta: {
                        ...presta.sendAllPresta,
                        [key]: value,
                    },
                };
            }
            return presta;
        });

        localStorage.setItem(`prestaHl_${conf.user.user_code}`, JSON.stringify(updatedPrestas));
    };

    useEffect(() => {
        if (details) {
            const newIndexPhases = details?.map((data: any) => {
                if (data.sous_categorie) {
                    const firstInvalidIndex = data?.sous_categorie.findIndex((sub: any) => sub?.isValid !== true);
                    return firstInvalidIndex !== -1 ? firstInvalidIndex : 0;
                }
                return 0;
            });
            // setIndexPhase(Number(newIndexPhases));
        }
    }, [details]);
    useEffect(() => {
        if (details) {
            setMaxIndex(details[0]?.sous_categorie?.length)
        }
    }, [details])
    const hasPInHierarchy = (item: any): boolean => {
        if (item?.rpl_type === "P") return true;
        if (Array.isArray(item?.sous_categorie)) {
            return item.sous_categorie.some((child: any) => hasPInHierarchy(child));
        }
        return false;
    };
    const hasAnyPhase = (items: any): boolean => {
        if (!Array.isArray(items)) return false; // sécurité
        return items.some(item => {
            if (item?.rpl_type === "P") return true;
            if (Array.isArray(item?.sous_categorie)) {
                return hasAnyPhase(item.sous_categorie);
            }
            return false;
        });
    };
    const isBL = (entete?: any) =>
        entete?.v_num_piece?.toLowerCase().startsWith("bl");
    const hasPhase = hasAnyPhase(details);
    // Regroupement des articles seuls type A
    // Initialisation


    return <>
        <div className="sizeDetailPresta">
            <div className="containerDetailPresta">
                <div className="containerTextPresta">
                    <p className="textDetailPresta"><FormattedMessage id="date" /> : {entete?.v_date_presta ? formatDateComplet(entete?.v_date_presta) : ""}</p>
                    <p className="textDetailPresta"><FormattedMessage id="event" /> : {entete?.v_designation}</p>
                    <p className="textDetailPresta">
                        {entete?.v_num_piece?.toLowerCase().startsWith("bl")
                            ? <FormattedMessage id="bl_number" defaultMessage="BL" />
                            : <FormattedMessage id="quote_number" defaultMessage="Devis" />
                        }
                        {" : "}
                        {entete?.v_num_piece}
                    </p>
                    <p className="textDetailPresta">{entete?.v_mode_vente}</p>
                </div>
                <div className="containerTextPresta">
                    <p className="textDetailPresta"> {entete?.v_cli_civ_nom}</p>
                    <p className="textDetailPresta"> {entete?.v_adr_livraison}</p>
                </div>
            </div>
        </div>
        <div className="container_modifPresta">
            {(isBL(entete) ? details.slice(1) : details)?.map((data: ListePresta) => (
                <div key={data.rpl_id}>
                    {Array.isArray(data?.sous_categorie) ?
                        data?.rpl_av_id !== null && data?.rpl_type !== "A" && (
                            <div className="card_modifPresta">
                                <div className="header_card_presta">
                                    <p>{data.rpl_designation}</p>
                                    <p>{data.rpl_id}</p>
                                </div>
                            </div>
                        )
                        : ""}
                    <div key={data?.rpl_id} className="subcategories">
                        {Array.isArray(data?.sous_categorie) ? (
                            <>
                                {data?.sous_categorie && data?.sous_categorie[0]?.rpl_av_id === null && data?.sous_categorie.length > 1 && (
                                    <div className={'phase'}>
                                        {data.sous_categorie.map((sub, index) => {
                                            return (

                                                <button
                                                    className={` ${indexPhase === index ? "neomorphicPhaseactiv" : "neomorphicPhase"} ${sub?.isValid === true ? "validPhase" : ''}`}
                                                    onClick={() => changePhase(index)}
                                                    key={index}
                                                >
                                                    {`${sub?.rpl_designation}`}
                                                </button>
                                            )
                                        })}
                                    </div>
                                )}

                                {
                                    data?.sous_categorie[indexPhase]?.rpl_av_id === null ?
                                        <RenderSubcategories
                                            subcategories={[data?.sous_categorie[indexPhase]]}
                                            detail={details}
                                            setDetails={setDetails}
                                            depth={0}
                                            parentId={data?.sous_categorie[indexPhase]?.rpl_id}
                                            setIsChecked={setIsChecked}
                                            isChecked={isChecked}
                                            details={data?.sous_categorie[indexPhase]}
                                        />
                                        :
                                        <RenderSubcategories
                                            subcategories={[data]}
                                            detail={details}
                                            setDetails={setDetails}
                                            depth={0}
                                            parentId={data?.sous_categorie[indexPhase]?.rpl_id}
                                            setIsChecked={setIsChecked}
                                            isChecked={isChecked}
                                            details={data?.sous_categorie[indexPhase]}
                                        />

                                }



                            </>
                        ) : (<>

                            <RenderSubNoSouscategories
                                key={data.rpl_id}
                                sub={data}
                                detail={details}
                                setDetails={setDetails}
                                parentId={data.rpl_id}
                                subcategories={data}
                                entete={entete}></RenderSubNoSouscategories>

                        </>)}
                    </div>

                    {
                        Array.isArray(data?.sous_categorie) ? (
                            <>
                                {data?.sous_categorie && data.sous_categorie.length > 0 ? (
                                    ([data?.sous_categorie[indexPhase]]).map((datas: any) => (
                                        <> {
                                            hasPhase && (
                                                <ValidationForm
                                                    source="datas"
                                                    datas={[datas]}
                                                    pvId={pvId}
                                                    devId={devId}
                                                    details={details}
                                                    presta={presta}
                                                    conf={conf}
                                                    selectedDate={selectedDate}
                                                    changeDate={changeDate}
                                                    handleSubmit={handleSubmit}
                                                    updateFn={updateInformationSign}
                                                    onValidate={validPrestationWithPhase}
                                                    showError={showError}
                                                    showModal={showModal}
                                                    setDetails={setDetails}
                                                    extraParams={[setIndexPhase, indexPhase, maxIndex]}
                                                    entete={entete}
                                                    mode="phase"
                                                />


                                            )}
                                            {datas?.rpl_type !== "P" && !hasPInHierarchy(datas) && (
                                                (

                                                    ([data]).map((datas: any) => (
                                                        <>
                                                            {

                                                                <ValidationForm
                                                                    source="datas"
                                                                    datas={[datas]}
                                                                    pvId={pvId}
                                                                    devId={devId}
                                                                    details={details}
                                                                    presta={presta}
                                                                    conf={conf}
                                                                    selectedDate={selectedDate}
                                                                    changeDate={changeDate}
                                                                    handleSubmit={handleSubmit}
                                                                    updateFn={updateInformationSignNoSousCat}
                                                                    onValidate={validPrestation}
                                                                    showError={showError}
                                                                    showModal={showModal}
                                                                    setDetails={setDetails}
                                                                    entete={entete}
                                                                    mode="offline"
                                                                />

                                                            }</>
                                                    ))
                                                )
                                            )
                                            } </>))
                                ) : ([data]).map((datas: any) => (
                                    <>
                                        {/* {

                                            <div key={datas.rpl_id}>
                                                <form onSubmit={handleSubmit}>
                                                    <div className="descriptionValid">
                                                        <span className="titleCategory">Commentaire :</span>
                                                        <InputTextArea
                                                            name=""
                                                            onChange={(e) => updateInformationSignNoSousCat(datas.rpl_id, 'e_observation_html', e)}
                                                            value={datas.informationSign?.e_observation_html == '' ? null : datas?.informationSign?.e_observation_html}
                                                            readOnly={datas?.isValid}
                                                        />
                                                    </div>
                                                    <div className="localisationValid">
                                                        <div className="dateValid">
                                                            <span className="titleCategory">A :</span>
                                                            <Input
                                                                readOnly={datas.isValid}
                                                                name=""
                                                                onChange={(e: any) => updateInformationSignNoSousCat(datas?.rpl_id, 'e_lieu_signature', e)}
                                                                value={datas?.informationSign?.e_lieu_signature}
                                                            />
                                                        </div>
                                                        <div className="dateValid">
                                                            <span className="titleCategory">Le :</span>
                                                            <div className="datepickerValid">
                                                                <LocalizationProvider language="fr-FR">
                                                                    <IntlProvider locale="fr">
                                                                        <DatePicker className="customPicker" format={"dd/MM/yyyy"} defaultValue={selectedDate} onChange={(e: any) => {
                                                                            changeDate(e.target.value)
                                                                        }} />
                                                                    </IntlProvider>
                                                                </LocalizationProvider>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="containerValidationPresta">
                                                        <div className="containerNameSignature">
                                                            <div className="sectionName">
                                                                <p className="titleCategory"><FormattedMessage id="nomResponsable" defaultMessage="Nom du Responsable" /></p>
                                                                <div className="namePresta">
                                                                    <Input
                                                                        name=""
                                                                        onChange={(e) => updateInformationSignNoSousCat(datas.rpl_id, 'e_nom_responsable', e)}
                                                                        value={datas?.informationSign?.e_nom_responsable}
                                                                        readOnly={datas?.isValid}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <ValidationPresta
                                                                signature={datas?.informationSign?.e_signature_responsable}
                                                                onUpdate={(key: string, value: string) => updateInformationSignNoSousCat(datas.rpl_id, key, value)}
                                                                inputKey="e_signature_responsable"
                                                                readOnly={datas?.isValid}
                                                            />
                                                        </div>
                                                        <div className="containerNameSignature">
                                                            <div className="sectionName">
                                                                <p className="titleCategory"><FormattedMessage id="nomClient" defaultMessage="Nom du Client" /></p>
                                                                <div className="namePresta">
                                                                    <Input
                                                                        name=""
                                                                        onChange={(e) => updateInformationSignNoSousCat(datas.rpl_id, 'e_nom_client', e)}
                                                                        value={datas?.informationSign?.e_nom_client}
                                                                        readOnly={datas?.isValid}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <ValidationPresta
                                                                signature={datas?.informationSign?.e_signature_client}
                                                                onUpdate={(key: string, value: string) => updateInformationSignNoSousCat(datas?.rpl_id, key, value)}
                                                                inputKey="e_signature_client"
                                                                readOnly={datas?.isValid}
                                                            />
                                                        </div>
                                                    </div>
                                                    {
                                                        // conf?.conf?.ifOffLineMode === false ?
                                                        <button type="submit" onClick={() => { validPrestation(datas?.rpl_id, 'isValid', showError, showModal, setDetails, conf) }} className='validButtonForms'>
                                                            Valider
                                                        </button>
                                                        //     :
                                                        // <button type="submit" onClick={() => { savePrestaHl(entete, details, sendAllPresta, showModal) }} className='validButtonForms'>
                                                        //     Enregistrer
                                                        // </button>
                                                    }
                                                </form>
                                            </div>

                                        }</> */}
                                    </>
                                ))}
                            </>
                        )
                            : ''}
                </div >
            ))
            }
            {Array.isArray(details)
                && details.length > 1
                && !details.some((datas: any) => datas.rpl_type === "P")
                && (
                    <>
                        {

                            <div key={details[0]?.rpl_id}>
                                <form onSubmit={handleSubmit}>
                                    <div className="descriptionValid">
                                        <span className="titleCategory">Commentaire :</span>
                                        <InputTextArea
                                            name=""
                                            onChange={(e) => updateInformationSignNoSousCat(details[0]?.rpl_id, 'e_observation_html', e)}
                                            value={details[0]?.informationSign?.e_observation_html == '' ? null : details[0]?.informationSign?.e_observation_html}
                                            readOnly={details[0]?.isValid}
                                        />
                                    </div>
                                    <div className="localisationValid">
                                        <div className="dateValid">
                                            <span className="titleCategory">A :</span>
                                            <Input
                                                readOnly={details[0]?.isValid}
                                                name=""
                                                onChange={(e: any) => updateInformationSignNoSousCat(details[0]?.rpl_id, 'e_lieu_signature', e)}
                                                value={details[0]?.informationSign?.e_lieu_signature}
                                            />
                                        </div>
                                        <div className="dateValid">
                                            <span className="titleCategory">Le :</span>
                                            <div className="datepickerValid">
                                                <LocalizationProvider language="fr-FR">
                                                    <IntlProvider locale="fr">
                                                        <DatePicker className="customPicker" format={"dd/MM/yyyy"} defaultValue={selectedDate} onChange={(e: any) => {
                                                            changeDate(e.target.value)
                                                        }} />
                                                    </IntlProvider>
                                                </LocalizationProvider>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="containerValidationPresta">
                                        <div className="containerNameSignature">
                                            <div className="sectionName">
                                                <p className="titleCategory"><FormattedMessage id="nomResponsable" defaultMessage="Nom du Responsable" /></p>
                                                <div className="namePresta">
                                                    <Input
                                                        name=""
                                                        onChange={(e: any) => updateInformationSignNoSousCat(details[0]?.rpl_id, 'e_nom_responsable', e)}
                                                        value={details[0]?.informationSign?.e_nom_responsable}
                                                        readOnly={details[0]?.isValid}
                                                    />
                                                </div>
                                            </div>
                                            <ValidationPresta
                                                signature={details[0]?.informationSign?.e_signature_responsable}
                                                onUpdate={(key: string, value: string) => updateInformationSignNoSousCat(details[0]?.rpl_id, key, value)}
                                                inputKey="e_signature_responsable"
                                                readOnly={details[0]?.isValid}
                                            />
                                        </div>
                                        <div className="containerNameSignature">
                                            <div className="sectionName">
                                                <p className="titleCategory"><FormattedMessage id="nomClient" defaultMessage="Nom du Client" /></p>
                                                <div className="namePresta">
                                                    <Input
                                                        name=""
                                                        onChange={(e: any) => updateInformationSignNoSousCat(details[0]?.rpl_id, 'e_nom_client', e.target.value)}
                                                        value={details[0]?.informationSign?.e_nom_client}
                                                        readOnly={details[0]?.isValid}
                                                    />
                                                </div>
                                            </div>
                                            <ValidationPresta
                                                signature={details[0]?.informationSign?.e_signature_client}
                                                onUpdate={(key: string, value: string) => updateInformationSignNoSousCat(details[0]?.rpl_id, key, value)}
                                                inputKey="e_signature_client"
                                                readOnly={details[0]?.isValid}
                                            />
                                        </div>
                                    </div>
                                    {
                                        details[0]?.isValid && !details[0]?.isSent ? (
                                            <button
                                                type="submit"
                                                onClick={() => { sendAllData([details[0]], pvId, devId, conf, showError, showModal, setDetails) }}
                                                className='validButtonForms'
                                            >
                                                Envoyer
                                            </button>
                                        ) : !details[0]?.isValid && !details[0]?.isSent ? (
                                            <button
                                                type="submit"
                                                onClick={() => { validPrestation(details[0]?.rpl_id, 'isValid', showError, showModal, setDetails, conf) }}
                                                className='validButtonForms'
                                            >
                                                Valider
                                            </button>
                                        ) : null
                                    }

                                </form>
                            </div>

                        }</>
                )}

        </div >
    </>

}
// const RenderSubcategories = ({subcategories, setDetails, depth = 0, parentId}: {subcategories: any, setDetails: any, depth: number, parentId: any }) => {
//     if (!subcategories) return null;
//     const isRoot = depth === 0;
//     return (
//         <>
//             {subcategories?.map((sub: any) => (
//                 <div key={sub.rpl_id} className={!isRoot && sub.sous_categorie ? `subcategory` : ''}>
//                     {sub.sous_categorie && sub.sous_categorie.length > 0 && <p className={!isRoot && sub.sous_categorie ? `titleCategory` : 'paddingCategory'}>{sub.rpl_designation}</p>}
//                     <div className={!isRoot && sub.sous_categorie ? `subcategorie_container` : 'paddingPresta'}>
//                         {sub.sous_categorie ? <RenderSubcategories subcategories={sub.sous_categorie} setDetails={setDetails} depth={depth + 1} parentId={parentId} /> : <RenderModifLine sub={sub} setDetails={setDetails} parentId={parentId} />}
//                     </div>
//                 </div>
//             ))}
//         </>
//     );
// };



//  